export class PlansService{constructor(apiService){this.apiService=void 0;this.apiService=apiService;}/**
   * Fetches plans with filtering and pagination
   */async getPlans(params){return this.apiService.get('/api/plans',params);}/**
   * Fetches a specific plan by ID
   */async getPlan(planId){return this.apiService.get(`/api/plans/${planId}`);}/**
   * Creates a new plan
   */async createPlan(plan){return this.apiService.post('/api/plans',plan);}/**
   * Updates an existing plan
   */async updatePlan(planId,plan){return this.apiService.put(`/api/plans/${planId}`,plan);}/**
   * Deletes a plan
   */async deletePlan(planId){return this.apiService.delete(`/api/plans/${planId}`);}}